import { useEffect, useState } from 'react'
import '../info/_component/menuInfoMgmt.css'
import { MenuInfoData, MenuType } from './menuInfoMgmtItem'
import DetailMenuInfoMgmt from './_component/detailMenuInfoMgmt'
import { useRedis } from '@/hooks/useRedis'
import SetMenuInfoMgmt from './_component/setMenuInfoMgmt'
import { useAxios } from '@/context/axiosContext'
import HistoryMenuInfoMgmt from './_component/historyMenuInfoMgmt'

const MenuInfoMgmt: React.FC = () => {
  const axios = useAxios()
  const [activeTab, setActiveTab] = useState('about')
  const { getComCodes, getComCodeValue } = useRedis()
  const [menuList, setMenuList] = useState<MenuInfoData[]>([])
  const [historyReloadFlag, setHistoryReloadFlag] = useState(false)

  // 이 함수를 DetailMenuInfoMgmt에 넘겨줍니다.
  const handleHistoryReload = () => {
    setHistoryReloadFlag((prev) => !prev) // 간단한 플래그 토글
  }

  useEffect(() => {
    getMenuInfoList() // path가 변경될 때마다 메뉴 정보를 새로 가져옴
  }, [])

  const getMenuInfoList = async () => {
    try {
      const response = await axios.get(`/menu/getMenuInfoList`)
      const menuList = response.data.data.menuList
      setMenuList(menuList)
    } catch (err) {
      console.error('Error fetching List:', err)
    }
  }

  return (
    <div className="tab-container">
      <div className="tab-buttons">
        {getComCodes('MENU_INFO').map((item) => (
          <button
            key={item.engCodeNm}
            className={activeTab === item.engCodeNm ? 'active' : ''}
            onClick={() => setActiveTab(item.engCodeNm)}
          >
            {item.codeNm}
          </button>
        ))}
      </div>
      <div className="tab-container">
        <div className="tab-content">
          {getComCodes('MENU_INFO').map((item) =>
            activeTab === item.engCodeNm ? (
              <div key={item.code}>
                <SetMenuInfoMgmt
                  path={item.engCodeNm}
                  label={item.codeNm}
                  code={item.code}
                  menuList={menuList}
                  getMenuInfoList={getMenuInfoList}
                />
              </div>
            ) : null,
          )}
        </div>
      </div>
      <div style={{ marginTop: '10px' }} />
      <div className="tab-content">
        {getComCodes('MENU_INFO').map(
          (menu) =>
            menu.engCodeNm === activeTab && (
              <>
                <div key={menu.engCodeNm}>
                  <DetailMenuInfoMgmt
                    path={menu.engCodeNm}
                    label={menu.codeNm}
                    menuList={menuList}
                    getMenuInfoList={getMenuInfoList}
                    onSaveSuccess={handleHistoryReload}
                  />
                </div>
              </>
            ),
        )}
      </div>
    </div>
  )
}

export default MenuInfoMgmt
